import { getServerRequest, patchServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export const cargarOficiosGeneradosService = async(page, search,filtro, tipo) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/generados?page=${page}&search=${search}&filter=${filtro}&words=${tipo}`;
    return await getServerRequest(url, config);
}

export const consecutivoService = async () => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/generados/numerosDisponibles`;
    return await getServerRequest(url, config);
}

export const cargarOficioGeneradoByIdService = async(idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/generado/${idOficio}`;
    return await getServerRequest(url, config);
}

export const obtenerHistoricoGeneradoByIdService = async (idOficio) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/generado/${idOficio}/historico`;
    return await getServerRequest(url, config);
}

export const modificarHistoricoGeneradoByIdService = async (idOficio, data) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }};
    const url = `${httpURL}/oficios/generado/${idOficio}/historico`;
    return await patchServerRequest(url, data, config);
}

export const generarReporteService = async (anio, periodo, tipo, reporte) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token }, responseType: "blob", };
    const url = `${httpURL}/oficios/generado/generarReporte/${anio}/${periodo}/${tipo}/${reporte}`;
    return await getServerRequest(url, config);
}